import { axios } from "../../lib/axios";

export const DeleteAnnouncement = (faqId: string) => {
    return axios.delete(`/announcement/${faqId}`)
        .then(response => response.data);
};